<template>
  <div class="content-container">
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="name" label="加盟商"> </el-table-column>
      <el-table-column label="分账比例">
        <template slot-scope="scope">
          {{ scope.row.rate }} %
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          name: "IBM",
          rate: 10
        },
        {
          name: "微软",
          rate: 20
        },
        {
          name: "华为",
          rate: 30
        }
      ]
    };
  },
  methods: {
    handleEdit() {}
  }
};
</script>

<style></style>
